import { IPromotionItemModel, IPromotionUpsellModel } from "../models";
import { sortItems } from "./sortItems";

export function getPromotionProducts(
    products: IPromotionItemModel[],
    upsells: IPromotionUpsellModel[] = [],
    selectedUpsellIds: number[] = []
): IPromotionItemModel[] {
    // We need a copy of the array so we can call .sort without causing an infinite loop
    // .sort mutates the array
    const promotionProducts = [...products];

    if (upsells && selectedUpsellIds) {
        selectedUpsellIds.forEach(id => {
            const upsell = upsells.find(u => u.id === id);
            if (upsell) {
                promotionProducts.push(upsell);
            }
        });
    }

    return sortItems(promotionProducts);
}
